import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../../Layout/Auth";
import LoginSuccessRedirectPage from '../../../Modules/Dashboard/Pages/LoginSuccessRedirectPage';
const Dashboard = lazy(() => import('../Pages/Dashboard'))
const DashboardV2 = lazy(() => import('../Pages/DashboardV2'))
const BillingCounterDashboard = lazy(() => import('../Pages/BillingCounterDashboard'))
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;


function DashboardRoute() {
    const history = useHistory();
    return (
        <Switch>
            <Route
                exact
                path="/"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent','agent_staff']}>
                        <LoginSuccessRedirectPage history={history} />
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/dashboard"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <Dashboard history={history} />
                        </Suspense>
                    </Auth>
                )}
            />  
            <Route
                exact
                path="/:lng/dashboard/v2"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <DashboardV2 history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/dashboard/billing-counter"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <BillingCounterDashboard history={history} />
                        </Suspense>
                    </Auth>
                )}
            />  
        </Switch>
    );
}
export default DashboardRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
